<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <a-form-model
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input
          v-model="form.name"
          placeholder="请输入名称"
          :disabled="disabeld"
        />
      </a-form-model-item>

      <!-- <a-form-model-item label="年份" prop="activityYear">
        <a-date-picker
          placeholder="请选择年份"
          v-model="form.activityYear"
          :open="yearPickerVisible"
          :locale="locale"
          format="YYYY"
          mode="year"
          @openChange="handleYearPickerOpen"
          @panelChange="handleYearSelect"
          @change="handleClearYear"
          style="width: 100%"
          :disabled="disabeld"
        />
      </a-form-model-item> -->

      <a-form-model-item label="类别" prop="type">
        <div class="flex">
          <a-select
            v-model="form.type"
            placeholder="请选择类别"
            @change="handleTypeChange"
            :disabled="disabeld"
          >
            <a-select-option
              v-for="item in activityTypes"
              :key="item.value"
              :value="item.text"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
          <a-input
            v-if="form.type === '其他'"
            v-model="form.otherType"
            class="ipt-other"
            placeholder="请输入其他类别"
           :disabled="disabeld"/>
        </div>
      </a-form-model-item>

      <a-form-model-item label="地点" prop="location">
        <a-input
          v-model="form.location"
          placeholder="请输入地点"
          :disabled="disabeld"
        />
      </a-form-model-item>

      <a-form-model-item label="人数" prop="partNum">
        <a-input-number
          v-model="form.partNum"
          :min="1"
          :precision="0"
          @blur="handleNumberBlur"
          :disabled="disabeld"
        />
      </a-form-model-item>

      <a-form-model-item label="人次" prop="personTime">
        <a-input-number
          v-model="form.personTime"
          :min="1"
          :precision="0"
          @blur="handleNumberBlur"
          :disabled="disabeld"
        />
      </a-form-model-item>
      <a-form-model-item label="时间" prop="holdingTime">
        <a-date-picker
          v-model="form.holdingTime"
          :locale="locale"
          :disabled="disabeld"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="活动主题">
        <div class="flex align-items-end">
          <a-textarea
            v-model="form.content"
            placeholder="请输入活动主题"
            :disabled="contentDisabled || disabeld"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
          <span class="primaryMisssonLabel">200字</span>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },

      form: {
        id: "",
        applyId: "",
        name: "",
        //activityYear: "",
        type: "",
        otherType: "",
        location: "",
        partNum: undefined,
        personTime: undefined,
        content: "",
        achievementType: "",
        amount: "",
        courseType: "",
        holdingTime: "",
      },

      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        // activityYear: [
        //   {
        //     required: true,
        //     validator: this.validateYear,
        //     trigger: "change",
        //   },
        // ],
        type: [
          { required: true, message: "请选择活动类别", trigger: "change" },
        ],
        location: [
          { required: true, message: "请输入活动地点", trigger: "blur" },
        ],
        partNum: [
          { required: true, message: "请输入参与人数", trigger: "blur" },
        ],
        personTime: [
          { required: true, message: "请输入参与人次", trigger: "blur" },
        ],
        holdingTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
      },

      yearPickerVisible: false,
      locale,
      applyType: 2,
      zh_CN,
      activityTypes: [],
      contentDisabled: false,
      isFirstAmount: true,
      isCourseTypeVisible: false,
      // 添加还是编辑
      mode: "add",
      title: "",
      disabeld: false,
    };
  },

  methods: {
    validateYear(rule, value, callback) {
      if (!value) {
        callback(new Error("请选择活动年份"));
      } else {
        callback();
      }
    },

    handleYearPickerOpen(open) {
      this.yearPickerVisible = open;
    },

    handleYearSelect(value) {
      this.form.activityYear = moment(value).format("YYYY");
      this.yearPickerVisible = false;
      this.$refs.formRef.clearValidate("activityYear");
    },

    handleClearYear() {
      this.form.activityYear = "";
      this.$forceUpdate();
    },

    handleTypeChange(value) {
      if (value === "SZKC") {
        this.isCourseTypeVisible = true;
      } else {
        this.isCourseTypeVisible = false;
        this.form.courseType = "";
      }
    },

    handleNumberBlur() {
      this.isFirstAmount = this.form.amount === "1";
      if (!this.isFirstAmount) {
        this.form.content = "";
      }
    },

    init(mode, record) {
      console.log("record", record);
      this.mode = mode;
      this.disabeld = false;
      this.visible = true;
      this.fetchActivityTypes();
      this.resetForm();
      if (mode === "add") {
        this.title = "新增品牌活动";
        this.resetForm();
        this.form.applyId = record.id;
        //this.form.activityYear = new Date().getFullYear().toString();
      } else if (mode == "edit") {
        this.title = "编辑品牌活动";
        console.log(record, "record");
        console.log(this.form, "this.form");
        this.setFormData(record);
      } else {
        this.title = "查看品牌活动";
        this.setFormData(record);
        this.disabeld = true;
      }
    },

    resetForm() {
      this.form = {
        id: "",
        applyId: "",
        name: "",
        activityYear: "",
        type: "",
        otherType: "",
        location: "",
        partNum: undefined,
        personTime: undefined,
        content: "",
        achievementType: "",
        amount: "",
        courseType: "",
        holdingTime: "",
      };
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate();
      });
    },

    setFormData(record) {
      const {
        id,
        name,
        achievementType,
        activityYear,
        type,
        applyId,
        otherType,
        amount,
        content,
        location,
        partNum,
        personTime,
        holdingTime,
        holdTime,
      } = record;

      // 表格/接口可能是 holdingTime 或 holdTime；旧 AI 数据可能只有 activityYear
      const rawTime = holdingTime || holdTime || "";
      let timeStr = rawTime
        ? moment(rawTime).isValid()
          ? moment(rawTime).format("YYYY-MM-DD")
          : String(rawTime)
        : "";
      if (!timeStr && activityYear && String(activityYear).length === 4) {
        timeStr = `${activityYear}-01-01`;
      }

      this.form = {
        ...this.form,
        id,
        name,
        achievementType,
        activityYear:
          activityYear ||
          (timeStr && String(timeStr).slice(0, 4).length === 4
            ? String(timeStr).slice(0, 4)
            : ""),
        type,
        applyId,
        otherType,
        amount,
        content,
        location,
        partNum,
        personTime,
        holdingTime: timeStr,
      };

      this.isFirstAmount = amount === "1";
      this.isCourseTypeVisible = achievementType === "SZKC";
    },

    fetchActivityTypes() {
      getAction("/baseCommon/getDictItemsByCode?code=brand_activity_type").then(
        (res) => {
          if (res.code === 200) {
            this.activityTypes = res.result;
          }
        }
      );
    },

    handleCancel() {
      this.visible = false;
    },

    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          console.error("表单验证失败");
          return false;
        }
        const params = this.prepareSubmitData();
        this.$message.success(this.mode === "add" ? "添加成功" : "编辑成功");
        this.visible = false;
        this.$emit("addActivity", { record: params, type: this.mode });
        // const apiCall =
        //   this.mode === "add"
        //     ? postAction("/lxBase/lxApplyActivity/add", params)
        //     : putAction("/lxBase/lxApplyActivity/edit", params);

        // apiCall
        //   .then((res) => {
        //     if (res.code === 200) {
        //       this.$message.success(
        //         this.mode === "add" ? "添加成功" : "编辑成功"
        //       );
        //       this.visible = false;
        //       this.$emit("addActivity");
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   })
        //   .finally(() => {
        //     this.confirmLoading = false;
        //   });
      });
    },

    prepareSubmitData() {
      const formData = { ...this.form };
      formData.applyType = this.applyType;

      // 统一时间字段，并回填 activityYear，避免总提交校验仍按旧字段报错
      let holdingTime = formData.holdingTime;
      if (holdingTime) {
        const m = moment(holdingTime);
        holdingTime = m.isValid() ? m.format("YYYY-MM-DD") : String(holdingTime);
      } else {
        holdingTime = "";
      }
      formData.holdingTime = holdingTime;
      formData.holdTime = holdingTime;
      if (holdingTime && holdingTime.length >= 4) {
        formData.activityYear = holdingTime.slice(0, 4);
      }

      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.ipt-other {
  margin-left: 12px;
}

.primaryMisssonLabel {
  display: inline-block;
  width: 60px;
  line-height: normal;
  margin-left: 12px;
}
</style>